import { useEffect } from "react";

import { strings } from "@perceptron/constants";
import { toast } from "sonner";

import { useDevModeStore, selectIsDevModeAvailable } from "@demo/store/dev-mode";

export const DEV_MODE_QUERY_PARAM = "perceptron-developer-mode";

/**
 * Grants developer mode when the URL carries `?perceptron-developer-mode=1`,
 * then strips the param so it doesn't linger in a copy-pasted URL. The grant
 * persists, so the param only has to appear once.
 *
 * Development and staging need no grant — the store reads availability from
 * the environment — so there the param only clears itself.
 */
export const useDevModeActivation = () => {
  const isGranted = useDevModeStore((s) => s.isGranted);
  const grant = useDevModeStore((s) => s.grant);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get(DEV_MODE_QUERY_PARAM) !== "1") return;

    if (!selectIsDevModeAvailable(useDevModeStore.getState())) {
      toast.success(strings.report.devModeEnabledToast);
    }
    if (!isGranted) grant();

    params.delete(DEV_MODE_QUERY_PARAM);
    const search = params.toString();
    window.history.replaceState({}, "", window.location.pathname + (search ? `?${search}` : "") + window.location.hash);
  }, [isGranted, grant]);
};
